// extracted by mini-css-extract-plugin
export default {"blogview":"blogview_cbac7792c1bdd898dda0"};